<template>
  <div class="gallery-container">
    <swiper class="swiper" :options="swiperOption" style="padding-top: 20px;" ref="gallery">
      <swiper-slide class="slide-item">
        <img v-if="$vuetify.breakpoint.smAndUp" src="../assets/image/image-hero-1-banner.png" alt="hero-1" />
        <img v-if="$vuetify.breakpoint.xs" class="small-hero-img" src="../assets/image/image-hero-1-mobile.png" alt="hero-1" />
      </swiper-slide>
      <swiper-slide class="slide-item">
        <img v-if="$vuetify.breakpoint.smAndUp" src="../assets/image/image-hero-2-banner.png" alt="hero-2" />
        <img v-if="$vuetify.breakpoint.xs" class="small-hero-img" src="../assets/image/image-hero-2-mobile.png" alt="hero-1" />
      </swiper-slide>
      <swiper-slide class="slide-item">
        <img v-if="$vuetify.breakpoint.smAndUp" src="../assets/image/image-hero-3-banner.png" alt="hero-3" />
        <img v-if="$vuetify.breakpoint.xs" class="small-hero-img" src="../assets/image/image-hero-3-mobile.png" alt="hero-1" />
      </swiper-slide>
      <swiper-slide class="slide-item">
        <img v-if="$vuetify.breakpoint.smAndUp" src="../assets/image/image-hero-4-banner.png" alt="hero-4" />
        <img v-if="$vuetify.breakpoint.xs" class="small-hero-img" src="../assets/image/image-hero-4-mobile.png" alt="hero-1" />
      </swiper-slide>
<!--      <swiper-slide class="slide-item">-->
<!--        <img v-if="$vuetify.breakpoint.smAndUp" src="../assets/image/image-hero-5-banner.png" alt="hero-5" />-->
<!--        <img v-if="$vuetify.breakpoint.xs" class="small-hero-img" src="../assets/image/image-hero-5-mobile.png" alt="hero-1" />-->
<!--      </swiper-slide>-->
    </swiper>
    <v-overlay :value="overlay" class="overlay-menu-cont" opacity="0.9">
      <div class="overlay-menu-items">
        <div>
          <div class="overlay-menu-item" @click="jumpToSlide(0)">Discover</div>
          <div class="overlay-menu-item" @click="jumpToSlide(1)">KOL Covers</div>
          <div class="overlay-menu-item" @click="jumpToSlide(2)">Our Mission</div>
          <div class="overlay-menu-item" @click="jumpToSlide(3)">Upload</div>
<!--          <div class="overlay-menu-item" @click="jumpToSlide(4)">Collab Lab</div>-->
        </div>
      </div>
    </v-overlay>
    <div class="menu-button-cont">
      <div v-if="!overlay" @click="onPressMenu" class="menu-text">Menu</div>
      <img @click="onPressClose" v-else id="close-overlay" src="../assets/image/close.png" alt="close"/>
    </div>
    <div class="gallery-buttons">
      <div class="gallery-button-container" @click="jumpToSlide(0)">
        <GalleryButton
            class="gallery-btn"
            title="Discover"
            color="#18c684"
            :icon="discoverIcon"
            iconWidth="17"
            iconHeight="22"
            :selected="currentSlide === 0"
        />
      </div>
      <div class="gallery-button-container" @click="jumpToSlide(1)">
        <GalleryButton
            class="gallery-btn"
            title="KOL Covers"
            :icon="theNeedIcon"
            iconWidth="17"
            iconHeight="16"
            :selected="currentSlide === 1"
        />
      </div>
      <div class="gallery-button-container" @click="jumpToSlide(2)">
        <GalleryButton
            class="gallery-btn"
            title="Our Mission"
            :icon="missionIcon"
            iconWidth="23"
            iconHeight="20"
            rotate
            :selected="currentSlide === 2"
        />
      </div>
      <div class="gallery-button-container" @click="jumpToSlide(3)">
        <GalleryButton
            class="gallery-btn"
            title="Upload"
            :icon="uploadIcon"
            iconWidth="25"
            iconHeight="18"
            :selected="currentSlide === 3"
        />
      </div>
<!--      <div class="gallery-button-container" @click="jumpToSlide(4)">-->
<!--        <GalleryButton-->
<!--            class="gallery-btn"-->
<!--            title="Collab Lab"-->
<!--            :icon="downloadIcon"-->
<!--            iconWidth="19"-->
<!--            iconHeight="19"-->
<!--            :selected="currentSlide === 4"-->
<!--        />-->
<!--      </div>-->
    </div>
  </div>
</template>
<script>
import { Swiper, SwiperSlide } from 'vue-awesome-swiper';
import GalleryButton from "./GalleryButton";
import 'swiper/css/swiper.css';
export default {
  name: 'Gallery',
  components: {
    GalleryButton,
    Swiper,
    SwiperSlide,
  },
  props:{
    getWindowContent: {
      type: Function
    },
    currentWindow: {
      type: Number
    }
  },
  data() {
    return {
      currentSlide: 0,
      discoverIcon: require('../assets/graphic/icon-musicnote.svg'),
      theNeedIcon: require('../assets/graphic/icon-star.svg'),
      missionIcon: require('../assets/graphic/icon-bolt.svg'),
      uploadIcon: require('../assets/graphic/icon-upload.svg'),
      downloadIcon: require('../assets/graphic/icon-download.svg'),
      overlay: false,
      swiperOption: {
        slidesPerView: 'auto',
        loop: true,
        centeredSlides: true,
        allowTouchMove: false,
        spaceBetween: 8,
      }
    }
  },
  methods: {
    jumpToSlide(index) {
      this.currentSlide = index;
      this.gallery.slideToLoop(index, 500);
      this.getWindowContent(index);
      window.removeEventListener('scroll', this.disableScroll);
      this.overlay = false;
    },
    disableScroll() {
      window.scrollTo(0, 0);
    },
    onPressMenu() {
      window.addEventListener('scroll', this.disableScroll);
      this.overlay = true;
    },
    onPressClose() {
      window.removeEventListener('scroll', this.disableScroll);
      this.overlay = false;
    }
  },

  computed: {
    gallery: function() {
      return this.$refs.gallery.$swiper;
    }
  },
  watch: {
    currentWindow: function() {
      this.currentSlide = this.currentWindow;
      this.gallery.slideToLoop(this.currentWindow, 250);
    }
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.disableScroll);
  }
}
</script>
<style lang="scss">
@import '~vuetify/src/styles/settings/_variables';
.gallery-container {
  align-items: center;
  background-color: black;
  padding-top: 0;
}

.gallery-buttons {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  background-color: black;
  padding: 2% 10px;
  margin: 0 2%;
}

.gallery-button-container {
  border-radius: 30px;
  margin: 0 12px;
}

.gallery-btn {
  cursor: pointer;
}

.gallery-btn:hover {
  background-color: #e1a732;
}

.slide-item {
  width: 750px;
  height: 430px;
  object-fit: cover;
}

.hero-img .bkg-gradient {
  object-fit: cover;
  width: 750px;
}

.menu-button-cont {
  display: none;
  color: white;
  width: 100%;
  background-color: #252525;
  padding: 15px;
  text-align: center;
  font-family: Lato-Regular, sans-serif;
  cursor: pointer;
  margin: 8px 0;
  & :hover {
    opacity: 0.8;
  }
}

.menu-button {
  height: 26px;
}

.menu-text {
  font-family: SSNicksonFour, serif;
  font-size: 17px;
}

.overlay-menu-cont {
  display: none;
  flex-direction: column;
  height: 322px;
  margin-top: 48px;
  position: fixed;
}

.overlay-menu-items {
  width: 100%;
  height: 100%;
  padding: 0;
  display: flex;
  flex-direction: column;
  align-items: center;

}

.overlay-menu-item {
  font-family: 'Lato-Bold', sans-serif;
  font-size: 17px;
  text-align: center;
  cursor: pointer;
  margin: 25px 0;
  & :hover {
    opacity: 0.5;
  }
}

#close-overlay {
  width: 34px;
  height: 26px;
  align-self: center;
  cursor: pointer;
  & :hover {
    opacity: 0.3;
  }
}

@media only screen and (max-width: 500px) {
  .slide-item {
    width: 288px;
    height: 275px;
  }

  .menu-button-cont {
    display: inherit;
  }

  .overlay-menu-cont {
    display: flex;
    height: 277px;
  }

  .gallery-buttons {
    display: none;
  }

  .gpvs-logo {
    width: 138px;
    height: 94px;
  }

  .slide-1-text {
    font-size: 14px;
    max-width: 300px;
  }
}

@media only screen and (min-width: 501px) and (max-width: 639px) {
  .gallery-button-container {
    margin: 5px;
    border-radius: 9px;
  }

  .slide-item {
    width: 450px;
    height: 350px;
  }

  .small-hero-img {
    width: 450px;
    height: 350px;
    object-fit: cover;
  }

  .gallery-buttons {
    display: none;
  }

  .overlay-menu-cont {
    display: flex;
    height: 353px;
  }

  .menu-button-cont {
    display: inherit;
  }
}

@media only screen and (max-width: 639px) {
  .gallery-container {
    padding-top: 5%;
  }

  .bkg-gradient {
    display: none;
  }

  .hero-img {
    display: none;
  }

  .hero-img-cont {
    align-items: flex-start;
  }

  .small-hero-img {
    display: inherit;
  }
}

@media only screen and (min-width: 641px) and (max-width: 767px) {
  .gallery-container {
    padding-top: 6%;
  }

  .slide-item {
    width: 550px;
  }

  .small-hero-img {
    display: inherit;
    width: 550px;
  }

  .bkg-gradient {
    display: none;
  }

  .hero-img {
    display: none;
  }

  .slide-text {
    font-size: 35px;
    width: 100%;
    text-align: center;
    margin-left: 0;
    margin-top: 130px;
  }

  .slide-2-text {
    font-size: 14px;
    margin-left: 0;
    margin-top: 30%;
    text-align: center;
  }

  .overlay-menu-cont {
    height: 402px;
  }

  .gallery-button-container {
    border-radius: 9px;
    margin: 0 8px;
  }
}

@media #{map-get($display-breakpoints, 'sm-and-down')} {
  .gallery-button-container {
    margin: 0 8px;
  }
}

@media #{map-get($display-breakpoints, 'xs-only')} {
  .gallery-container {

  }
}

@media #{map-get($display-breakpoints, 'md-only')} {
  .slide-item .hero-img .bkg-gradient {
    width: 600px;
    object-fit: cover;
  }

  .menu-button-cont {
    display: none;
  }

  .overlay-menu-cont {
    display: none;
  }

  .gallery-button-container {
    margin: 0 12px;
  }
}

</style>